<label class="checkbox-control">
  <input type="checkbox" [(ngModel)]="selected" (ngModelChange)="onSelectedChange($event)" [attr.aria-label]="filterBase.label">
  <span class="checkbox-mark"><mat-icon>check</mat-icon></span>
  <span>{{ !hideTitle ? filterBase.label : '' }}</span>
</label>
